import {FormGroup} from "@angular/forms";
import {ErrorMessageEnum} from "../enums/error-message.enum";
import {CategoryTypeEnum} from "../enums/category-type.enum";

/**
 * This util will provide validations for event creation and edit forms
 */
export class EventFormValidationUtil {

  static displayFrontEndFormErrors(eventForm: FormGroup, eventCategory: string) {

    let apiErrors: Map<string, string> = new Map<string, string>()

    if (!eventForm.valid) {

      apiErrors = this.displayGeneralErrors(eventForm)

      switch (eventCategory) {
        case CategoryTypeEnum.pessoa:
          apiErrors = EventFormValidationUtil.appendApiErrorMap(this.displayPeopleErrors(eventForm), apiErrors);
          break
        case CategoryTypeEnum.veiculo:
          apiErrors = EventFormValidationUtil.appendApiErrorMap(this.displayVehicleErrors(eventForm), apiErrors);
          break
        case CategoryTypeEnum.documento:
          apiErrors = EventFormValidationUtil.appendApiErrorMap(this.displayDocumentErrors(eventForm), apiErrors);
          break
      }
    }

    return apiErrors;
  }

  //validate general field errors
  private static displayGeneralErrors(eventForm: FormGroup) {

    let apiErrors: Map<string, string> = new Map<string, string>()

    //category
    if (eventForm.get("category")?.hasError("required")) {
      apiErrors.set('category', ErrorMessageEnum.requiredField)
    }
    if (eventForm.get("intent")?.hasError("required")) {
      apiErrors.set('intent', ErrorMessageEnum.requiredField)
    }
    //title
    if (eventForm.get("title")?.hasError("required")) {
      apiErrors.set('title', ErrorMessageEnum.requiredField)
    }
    //contact
    if (eventForm.get("contact")?.hasError("required")) {
      apiErrors.set('contact', ErrorMessageEnum.requiredField)
    }
    //description
    if (eventForm.get("description")?.hasError("required")) {
      apiErrors.set('description', ErrorMessageEnum.requiredField)
    }
    //province
    if (eventForm.get("province")?.hasError("required")) {
      apiErrors.set('province', ErrorMessageEnum.requiredField)
    }
    //eventDate
    if (eventForm.get("eventDate")?.hasError("required")) {
      apiErrors.set('eventDate', ErrorMessageEnum.requiredField)
    }
    return apiErrors;
  }

  /**
   *  validate event form document section
   * @param eventForm
   */
  static displayDocumentErrors(eventForm: FormGroup) {
    let apiErrors: Map<string, string> = new Map<string, string>()

    //documentType
    if (eventForm.get("documentType")?.hasError("required")) {
      apiErrors.set('documentType', ErrorMessageEnum.requiredField)
    }
    return apiErrors;
  }

  /**
   *  validate event form vehicle section
   * @param eventForm
   */
  static displayVehicleErrors(eventForm: FormGroup) {
    let apiErrors: Map<string, string> = new Map<string, string>()

      //brand
      if (eventForm.get("brand")?.hasError("required")) {
        apiErrors.set('brand', ErrorMessageEnum.requiredField)
      }
      //model
      if (eventForm.get("model")?.hasError("required")) {
        apiErrors.set('model', ErrorMessageEnum.requiredField)
      }
      //licensePlate
      if (eventForm.get("licensePlate")?.hasError("required")) {
        apiErrors.set('licensePlate', ErrorMessageEnum.requiredField)
      }

    return apiErrors;
  }


  /**
   *  validate event form people section
   * @param eventForm
   */
  static displayPeopleErrors(eventForm: FormGroup) {

    let apiErrors: Map<string, string> = new Map<string, string>()

    //names
    if (eventForm.get("names")?.hasError("required")) {
      apiErrors.set('names', ErrorMessageEnum.requiredField)
    }
    //gender
    if (eventForm.get("gender")?.hasError("required")) {
      apiErrors.set('gender', ErrorMessageEnum.requiredField)
    }
    //birthDate
    if (eventForm.get("birthDate")?.hasError("required")) {
      apiErrors.set('birthDate', ErrorMessageEnum.requiredField)
    }
    return apiErrors;
  }


  static appendApiErrorMap(source: Map<string, string>, target: Map<string, string>) {
    source.forEach((value, key) => target.set(key, value))
    return target;
  }

}
